export enum ButtonIconType {
	RAISED = 'raised',
	FLAT = 'flat',
}
